var keys = function keys(value) {
  return value ? Object.keys(value) : [];
};

export default keys;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/structure/plain/keys.js
// module id = 2053
// module chunks = 0